export default "__VITE_ASSET__fe3fd5f9__"